import React from 'react';
import classNames from 'classnames';

import TmoButton from './forms/TmoButton';
import { FaFileDownload } from 'react-icons/all';

import style from './ExportJSONDataAsFile.module.css';

function ExportJSONDataAsFile({
  data,
  className,
  buttonText,
  fileName,
  fileExtension
}) {
  const exportData = (data, fileName) => {
    const json = JSON.stringify(data);
    const blob = new Blob([json], { type: 'application/json' });
    const link = document.createElement('a');
    if (link.download !== undefined) {
      const url = URL.createObjectURL(blob);
      link.setAttribute('href', url);
      link.setAttribute('download', `${fileName}.${fileExtension}`);
      link.style.visibility = 'hidden';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
  };

  return (
    <TmoButton
      className={classNames(style.button, className)}
      onClick={() => exportData(data, fileName)}
      icon={<FaFileDownload />}
    >
      {buttonText ? buttonText : 'Export Data'}
    </TmoButton>
  );
}

export default ExportJSONDataAsFile;
